export default{
  basic_information: '工厂概况',
  main_products: '主要产品',
  factory_area:'工厂区域情况',
  certifications: '证书情况',
  inspections: '验货',
  manufacturing_process: '主要生产工序',
  quality_management: '质量管理体系',
  base: {
    factory_name: '工厂名称',
    factory_address: '工厂地址',
    fPS_coordinates_at_main_entry: '工厂GPS定位',
    established_date: '成立日期',
    audit_date: '审核日期',
    auditor: '审核员',
    number_of_r_d_engineers:'研发打样人员数量',
    sample_lead_time:'样品前置时间',
    summary: '审核汇总简介',
    main_customers:'排名前三的主要客户',
    customer_number: '编号#',
    customer_name: '客户名称',
    customer_country: '国家',
    customer_turnover: '占年产值比例'
  },
  products:{
    typology : '产品类型',
    standard: '生产标准前置时间',
    capacity: '月产能'
  },
  certifications_title:{
    certification: '证书/批文',
    regulatory: '是否法规要求',
    compliance: '是否符合',
    remark: '备注说明',
    certifications: '证书照片',
    additional_photos: '其它照片',
    certifications_1:'证书'
  },
  process:{
    index: '编号#',
    manufacturing: '主要生产工序',
    machines: '使用的主要设备和数量',
    maximum: '最大日产能',
    number: '该工序员工数量',
    remark: '备注说明'
  },
  view:{
    summary: '概述',
    contents: '内容',
    plan: '布局',
    fullscreen:'全屏',
    report: '报告',
    cover_title: '工厂审核报告',
    overview: '查看',
    press: '按下鼠标，拖动查看',
    building_number: '建筑编号',
    processTitle: '功能分类'
  }
}